"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var Color_1 = __importDefault(require("../Variables/Color"));
var margin_1 = __importDefault(require("../Utils/margin"));
var padding_1 = __importDefault(require("../Utils/padding"));
var Card = styled_components_1.default.article(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  background: ", ";\n  box-sizing: border-box;\n  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.04);\n  border-radius: 12px;\n\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  background: ", ";\n  box-sizing: border-box;\n  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.04);\n  border-radius: 12px;\n\n  ", "\n  ", "\n"])), margin_1.default, padding_1.default, Color_1.default.BRAND_WHITE, function (_a) {
    var background = _a.background;
    return (background ? "background: ".concat(background, ";") : '');
}, function (_a) {
    var onClick = _a.onClick;
    return onClick && 'cursor: pointer;';
});
Card.defaultProps = {
    padding: 'MD',
};
exports.default = Card;
var templateObject_1;
